/* eslint-disable */
export default {
  title: 'Regione',
  NAOnlyMessage: 'Imposta il prefisso. Verrà usato per le chiamate locali.',
  MultiWithNAMessage:
    'Imposta i prefissi locale e internazionale. Verranno utilizzati per la formattazione dei numeri di telefono e le chiamate locali.',
  MultiWithoutNAMessage:
    'Seleziona il paese in cui ti trovi. Verranno utilizzati per la formattazione dei numeri di telefono e le chiamate locali.',
  country: 'Paese',
  areaCode: 'Prefisso',
  areaCodePlaceholder: 'Immetti prefisso',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
